import React, { useContext, useEffect, useState, useCallback } from "react";
import useSize from "../../../Utils/useSize/useSize";
import Total from "./Total/Total";
import Trade from "./Trade/Trade";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import Socket from "../../../context/SocketContext";
import ActiveUserModal from "./ActiveUserModal/ActiveUserModal";

const backend = await new Backend().init();

export default function Home() {
  const socket = useContext(Socket);
  const windowSize = useSize();

  const userType = Number(localStorage.getItem("user_type") || 9);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [homeData, setHomeData] = useState({
    other: [],
    trade: [],
    pending: [],
    logs: [],
    history: [],
    supers: 0,
    master: 0,
    user: 0,
    broker: 0,
    tbuy: 0,
    tsell: 0,
    turnover: 0,
  });

  /** ✅ Centralized API call */
  const loadHome = useCallback(() => {
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    };

    // Add role-specific ID
    if (userType === 1) data.admin_id = data.id;
    else if (userType === 2) data.super_id = data.id;
    else if (userType === 3) data.master_id = data.id;
    else if (userType === 5) data.broker_id = data.id;
    else if (userType === 6) data.subbroker_id = data.id;

    backend.home(data).then((r) => {
      setLoading(false);

      if (r.error === "False") {
        setHomeData({
          other: r.other,
          trade: r.trade,
          pending: r.pending,
          logs: r.logs,
          history: r.history,
          supers: r.super,
          master: r.master,
          user: r.user,
          broker: r.broker,
          tbuy: r.buy,
          tsell: r.sell,
          turnover: r.turnover,
        });
      } else {
        if (r.logout === 1) {
          window.LogOut?.();
        } else {
          toast.error(r.message);
        }
      }
    });
  }, [userType]);

  /** ✅ Socket reload handler */
  const reload = useCallback(
    (payload) => {
      console.log(payload, "payloadpayloadpayload");

      const id = localStorage.getItem("id");
      const match = {
        1: payload.admin,
        2: payload.super,
        3: payload.master,
        5: payload.broker,
        6: payload.subbroker,
      }[userType];

      if (match && id === String(match)) {
        loadHome();
      }
    },
    [userType, loadHome],
  );

  /** ✅ Mount / unmount socket listener */
  useEffect(() => {
    loadHome();
    socket.on("reload", reload);
    return () => socket.off("reload", reload);
  }, [socket, reload, loadHome]);

  const { supers, master, user, broker, tbuy, tsell, turnover, trade } =
    homeData;

  const handleOpenModal = () => setModal(true);
  const handleCloseModal = () => setModal(false);

  return (
    <div
      style={{
        width: windowSize[0],
        height: windowSize[1] - 100,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ActiveUserModal open={modal} close={handleCloseModal} />
      <Total
        supers={supers}
        master={master}
        user={user}
        broker={broker}
        tbuy={tbuy}
        tsell={tsell}
        turnover={turnover}
        loading={loading}
        userType={userType}
        handleOpenModal={handleOpenModal}
      />

      <Trade trade={trade} userType={userType} />
    </div>
  );
}
